import React, { useState } from "react";
import { Button, Col, Form, InputNumber, Row, Space, Tag, Typography, message } from "antd";
import { AimOutlined, DeleteOutlined, EnvironmentFilled } from "@ant-design/icons";
import { getBrowserLocation, locationErrorText, validCoordinates } from "../utils/geolocation";

const BuildingLocationPicker = ({ form }) => {
    const [locating, setLocating] = useState(false);
    const latitude = Form.useWatch("latitude", form);
    const longitude = Form.useWatch("longitude", form);
    const located = validCoordinates({ latitude, longitude });

    const locate = async () => {
        if (locating) return;
        setLocating(true);
        try {
            const next = await getBrowserLocation();
            form.setFieldsValue(next);
            message.success("已获取当前地图位置，请核对坐标");
        } catch (error) {
            message.warning(locationErrorText(error));
        } finally {
            setLocating(false);
        }
    };

    const clear = () => form.setFieldsValue({ latitude: null, longitude: null, accuracy: null });

    return (
        <div className="building-location-picker">
            <Space wrap style={{ marginBottom: 12 }}>
                <Button icon={<AimOutlined />} loading={locating} disabled={locating} onClick={locate}>获取当前位置</Button>
                {located && <Button icon={<DeleteOutlined />} onClick={clear}>清除定位</Button>}
                <Tag color={located ? "green" : "default"}>{located ? "已标记地图位置" : "尚未定位"}</Tag>
            </Space>
            <Row gutter={12}>
                <Col xs={24} sm={12}><Form.Item name="latitude" label="纬度" rules={[{ type: "number", min: -90, max: 90, message: "纬度应在-90至90之间" }]}><InputNumber precision={7} style={{ width: "100%" }} placeholder="例如 22.543096" /></Form.Item></Col>
                <Col xs={24} sm={12}><Form.Item name="longitude" label="经度" rules={[{ type: "number", min: -180, max: 180, message: "经度应在-180至180之间" }]}><InputNumber precision={7} style={{ width: "100%" }} placeholder="例如 114.057865" /></Form.Item></Col>
            </Row>
            <div className={`building-location-preview${located ? " is-located" : ""}`}>
                <EnvironmentFilled />
                <strong>{located ? "楼栋位置已标记" : "等待定位"}</strong>
                <span>{located ? `${Number(latitude).toFixed(6)}, ${Number(longitude).toFixed(6)}` : "获取当前位置或手动填写经纬度"}</span>
            </div>
            <Typography.Text type="secondary">楼栋坐标只用于计算附近房源；普通用户的当前位置仅用于本次排序，不保存到系统。</Typography.Text>
        </div>
    );
};

export default BuildingLocationPicker;
